import React from 'react';
import IssueReportsPage from '../../issueReports/IssueReportsPage';
import { paths } from '../../../routes';

export default function IssueReports() {

    const cardInfo = {
        titleKey: 'doorSize',
        titleTranslationKey: '',
        subTitleKey: 'issueType',
        descriptionKey: 'message',
    };

    return (
        <IssueReportsPage
            cardInfo={cardInfo}
            addIssueReportPath={paths.rentalAddIssueReports}
            serviceType={'apartment'}
        />
    );
}
